import React from "react";
// import flexible from '../../utils/flexible';
import "./index.less";
import img1 from "./img/1.png";
import img2 from "./img/2.png";
import img3 from "./img/3.png";
import img4 from "./img/4.png";
import img5 from "./img/5.png";
import img6 from "./img/6.png";
import img7 from "./img/7.png";

class RemoteSmartLinkIOT extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    // document.title = '关于绿色慧联';
    return (
      <div className="remoteSmartLinkIOT">
        <div id="remoteSmartLinkIOT">
          <section className="no-one">
            <img src={img1} alt="" />
          </section>
          <section className="no-two">
            <img src={img2} alt="" />
          </section>
          <section className="no-three">
            <img src={img3} alt="" />
          </section>
          <section className="no-four">
            <img src={img4} alt="" />
          </section>
          <section className="no-five">
            <img src={img5} alt="" />
          </section>
          <section className="no-six">
            <img src={img6} alt="" />
          </section>
          <section className="no-seven">
            <img src={img7} alt="" />
          </section>
        </div>
      </div>
    );
  }
}

export default RemoteSmartLinkIOT;



// WEBPACK FOOTER //
// ./src/staticPage/remoteSmartLinkIOT/index.js